import Image from 'next/image';

interface CountryFlagProps {
  code: string;
  size?: number;
  className?: string;
}

export function CountryFlag({ code, size = 24, className }: CountryFlagProps) {
  const lowerCode = code.toLowerCase();
  return (
    <Image
      src={`https://flagcdn.com/w80/${lowerCode}.png`}
      width={size}
      height={Math.round(size * 0.75)}
      alt={`${code} flag`}
      className={className}
      unoptimized
      style={{ display: 'inline-block', verticalAlign: 'middle', objectFit: 'contain' }}
    />
  );
}

export function getFlagUrl(code: string, width = 80): string {
  return `https://flagcdn.com/w${width}/${code.toLowerCase()}.png`;
}
